<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
               <div class="d-flex justify-content-start w-100">
                 <h2 style="font-size: 1.2vw !important;width: 10vw;">مدیریت عملکرد      </h2>

               </div>


              </div>

              <div class="d-flex justify-content-start mb-2">
                 <div  class="d-flex flex-column col-3 mx-2">
                   <label for="">نوع گزارش</label>
                   <select v-model="type_report" name="" id="" class="form-select">
                     <option value="" selected disabled>انتخاب کنید</option>
                     <option value="1">مبتنی بر فرآیند - تفضیلی</option>
                     <option value="2">مبتنی بر پست سازمانی - تفضیلی</option>
                     <option value="3">مبتنی بر فرآیند - تجمیعی</option>
                     <option v-if="false" value="4">مبتنی بر  پست سازمانی - تجمیعی</option>
                   </select>
                 </div>
                <div v-if="parseInt(type_report)===1||parseInt(type_report)===2" class="d-flex flex-column col-3">

                <!--          همه شرکت های تابعه(چک باکس باشه همشو انتخاب کنه) یا انتخاب یک یا چند شرکت       -->
                 <label for="">شرکت های تابعه  </label>
                 <select v-model="company_id"   class="form-select">
                   <option value="" selected disabled>انتخاب کنید</option>
                   <option v-for="item in all_users" :value="item.id">{{item.name}}</option>

                 </select>
               </div>
                <div v-if="parseInt(type_report)===3||parseInt(type_report)===4" class="d-flex flex-column col-3">

                <!--          همه شرکت های تابعه(چک باکس باشه همشو انتخاب کنه) یا انتخاب یک یا چند شرکت       -->
                 <label for="">شرکت های تابعه  </label>
                  <input @click.prevent="fetchCompanies" class="form-control" type="text" :readonly="true"
                         :placeholder="companies_selected.length ? selectedCompaniesNames :`انتخاب کنید`">
               </div>

                <div v-if="(parseInt(type_report)===1 || parseInt(type_report)===3) " class="d-flex flex-column col-3 mx-2">
                  <label for="">فرآیند ها  </label>
                  <input @click.prevent="fetchProcess" class="form-control" type="text" :readonly="true"
                         :placeholder="process_selected.length ? selectedProcessNames :`انتخاب کنید`">
                </div>
                <div v-if="(parseInt(type_report)===2 || parseInt(type_report)===4)" class="d-flex flex-column col-3 mx-2">
                  <label for="">پست های سازمانی  </label>
                  <input @click.prevent="fetchOrgans" class="form-control" type="text" :readonly="true"
                         :placeholder="organ_list_selected.length ? selectedCuratorNames :`انتخاب کنید`">

                </div>
                <div class="d-flex flex-row col-3 mx-2">
                  <button :disabled="loader" @click.prevent="ExportExcel" class="btn btn-primary btn-submit-1" style="transform: translateY(1.7vw)">مشاهده گزارش</button>
                 <Reset v-if="company_id" @click.prevent="ResetAll" style="width: 1.5vw;height: 1.5vw; transform: translateX(-1vw) translateY(1.7vw)"/>
                </div>
              </div>

            <hr>
            </div>
            <center v-if="!all_items.length" style="font-size: 1vw;" class="mt-3" >
              <p v-if="!loading">اطلاعاتی یافت نشد</p>
              
              <div v-if="loading" class="d-flex flex-column align-items-center">
                <div  style="background-image: url('/img/convert.gif'); height: 20vw; width: 20vw; background-repeat: no-repeat; background-size: contain;"></div>
                <p style="transform: translateY(-10vw); font-size: 1vw;"> درحال آماده سازی گزارش...</p>
              </div>
            </center>
            <div v-if="all_items.length" class=" mt-3">
              <div style="overflow-y: scroll; height: 50vw;" :style="all_items.length < 19 ? 'height: auto;' : ''">
                <table v-if="parseInt(type_report)===1"  class="table table-striped">
                  <thead>
                    <tr class="sticky-header">
                      <th>ردیف</th>
                      <th>فرآیند</th>
                      <th>متولی</th>
                      <th>تواتر</th>
                      <th>متوسط زمان اجرا(دقیقه)
                      </th>
                      <th>محاسبات</th>
                    </tr>
                  </thead>
                  <tr v-for="(item, index) in all_items" :style="item.process==='مجموع' ? `background-color: yellow !important`: ''">
                    <td>{{index+1}}</td>
                    <td>{{item.process}}</td>
                    <td>{{item.TasksProcessForOrganizationposts}}</td>
                    <td>{{item.frequency}}</td>
                    <td>{{item.total_average_time}}</td>
                    <td>{{item.calculation}}</td>
                   </tr>
                </table>
                <table v-else-if="parseInt(type_report)===2" class="table table-striped">
                  <thead>
                    <tr class="sticky-header">
                      <th>ردیف</th>
                      <th>متولی</th>
                      <th>فرآیند</th>
                      <th>تواتر</th>
                      <th>متوسط زمان اجرا(دقیقه)
                      </th>
                      <th>محاسبات</th>
                    </tr>
                  </thead>
                  <tr v-for="(item, index) in all_items" :style="item.process==='مجموع' ? `background-color: yellow !important`: ''">
                    <td>{{index+1}}</td>
                    <td>{{item.TasksProcessForOrganizationposts}}</td>
                    <td>{{item.process}}</td>
                    <td>{{item.frequency}}</td>
                    <td>{{item.total_average_time}}</td>
                    <td>{{item.calculation}}</td>
                   </tr>
                </table>
                <table v-else-if="parseInt(type_report) === 3" class="table table-striped">
                  <thead>
                  <tr class="sticky-header">
                    <th rowspan="3">ردیف</th>
                    <th rowspan="3">نام فرآیند</th>
                    <th rowspan="3">واحد سنجش</th>
                    <template v-for="level in [1, 2, 3,4]">
                      <th v-if="all_items[0] .companies.some(company => company.level === level)" :colspan="all_items[0].companies.filter(company => company.level === level).length">
                        <span v-if="level === 1">مراکز بزرگ</span>
                        <span v-if="level === 2">مراکز متوسط </span>
                        <span v-if="level === 3">مراکز کوچک</span>
                        <span v-if="level === 4">ادارات کل</span>
                      </th>
                    </template>
                  </tr>
                  <tr class="sticky-header">
                    <template v-for="level in [1, 2, 3,4]">
                      <template v-for="company in all_items[0].companies.filter(company => company.level === level)">
                        <th>{{ company.company_name }}</th>
                      </template>
                    </template>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(item, index) in all_items">
                    <tr>
                      <td :rowspan="3">{{ index + 1 }}</td>
                      <td :rowspan="3">{{ item.process_name }}</td>
                      <td>فراوانی در سال</td>
                      <template v-for="level in [1, 2, 3,4]">
                        <template v-for="company in item.companies.filter(company => company.level === level)">
                          <td>{{ company.total_frequency }}</td>
                        </template>
                      </template>
                    </tr>
                    <tr>
                      <td>میانگین پایه در ماه</td>
                      <template v-for="level in [1, 2, 3,4]">
                        <template v-for="company in item.companies.filter(company => company.level === level)">
                          <td>{{ company.average_execution_time }}</td>
                        </template>
                      </template>
                    </tr>
                    <tr>
                      <td>حجم کار محاسبه شده</td>
                      <template v-for="level in [1, 2, 3,4]">
                        <template v-for="company in item.companies.filter(company => company.level === level)">
                          <td>{{ company.total_calculations }}</td>
                        </template>
                      </template>
                    </tr>
                  </template>
                  </tbody>
                </table>



                <table v-else-if="parseInt(type_report)===4" class="table table-striped">
                  <thead>
                    <tr class="sticky-header">
                      <th>ردیف</th>
                      <th>متولی</th>
                      <th>فرآیند</th>
                      <th>تواتر</th>
                      <th>متوسط زمان اجرا(دقیقه)
                      </th>
                      <th>محاسبات</th>
                    </tr>
                  </thead>
                  <tr v-for="(item, index) in all_items" :style="item.process==='مجموع' ? `background-color: yellow !important`: ''">
                    <td>{{index+1}}</td>
                    <td>{{item.TasksProcessForOrganizationposts}}</td>
                    <td>{{item.process}}</td>
                    <td>{{item.frequency}}</td>
                    <td>{{item.total_average_time}}</td>
                    <td>{{item.calculation}}</td>
                   </tr>
                </table>



            </div>
              <hr v-if="file_link" class="mt-3">
              <center v-if="file_link" class="mt-3">
                <a target="_blank" class="btn btn-submit-1 btn-primary" :href="file_link">
                  خروجی اکسل
                </a>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div dir="rtl" class="modal__error slide-top" v-if="select_curator" style="z-index: 999999999999999">
    <div>
      <p>انتخاب پست های سازمانی</p>
      <p @click="select_curator=!select_curator">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text" placeholder="جستجو بر اساس نام و نام خانوادگی  ...">
      <div style="overflow-y: scroll; height: 15vw; margin-bottom: 1vw;" class="w-100">
        <table class="table table-striped w-100">
          <thead>
          <tr class="sticky-header">
            <th style="width: 1vw;">
              <input type="checkbox" @change="toggleAll($event)" />
            </th>
            <th>پست سازمانی</th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in filteredCurator" :key="item.id">
          <tr>
            <td scope="row">
              <input :id="`id_${item.id}`" v-model="organ_list_selected" type="checkbox" :value="item['id']">
            </td>
            <td>
              <label :for="`id_${item.id}`">
                {{ item['name'] }}
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex">
        <button class="btn btn-submit-1 btn-primary mx-2" @click="select_curatorMethod">تایید</button>
      </div>
    </div>
  </div>


  <div dir="rtl" class="modal__error slide-top" v-if="select_process" style="z-index: 999999999999999">
    <div>
      <p>انتخاب فرآیند  </p>
      <p @click="select_process=!select_process">❌</p>
    </div>
    <div>
      <input v-model="search_process" class="form-control mb-3" type="text" placeholder="جستجو بر اساس نام فرآیند  ...">
      <div style="overflow-y: scroll; height: 15vw; margin-bottom: 1vw;" class="w-100">
        <table class="table table-striped w-100">
          <thead>
          <tr class="sticky-header">
            <th style="width: 1vw;">
              <input type="checkbox" @change="toggleAllProcess($event)" />
            </th>
            <th>انتخاب فرآیند </th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in filteredProcess" :key="item.id">
          <tr>
            <td scope="row">
              <input :id="`id2_${item.code}`" v-model="process_selected" type="checkbox" :value="item.code">
            </td>
            <td>
              <label :for="`id2_${item.code}`">
                {{ item['name']??item.title }}
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex">
        <button class="btn btn-submit-1 btn-primary mx-2" @click="select_processMethod">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-if="select_user" style="z-index: 999999999999999">
    <div>
      <p>انتخاب شرکت   </p>
      <p @click="select_user=!select_user">❌</p>
    </div>
    <div>
      <input v-model="search_user" class="form-control mb-3" type="text" placeholder="جستجو بر اساس نام فرآیند  ...">
      <div style="overflow-y: scroll; height: 15vw; margin-bottom: 1vw;" class="w-100">
        <table class="table table-striped w-100">
          <thead>
          <tr class="sticky-header">
            <th style="width: 1vw;">
              <input type="checkbox" @change="toggleAllCompanies($event)" />
            </th>
            <th>انتخاب فرآیند </th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in filteredCompanies" :key="item.id">
          <tr>
            <td scope="row">
              <input :id="`id2_${item.id}`" v-model="companies_selected" type="checkbox" :value="item.id">
            </td>
            <td>
              <label :for="`id2_${item.id}`">
                {{ item['name'] }}
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex">
        <button class="btn btn-submit-1 btn-primary mx-2" @click="select_CompaniesMethod">تایید</button>
      </div>
    </div>
  </div>













</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import cookies from "vue-cookies";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
const toast = useToast();

export default {
  name: "ListUser",
  components: {Reset, Sidebar, Splash,},
  data() {
    return {
      select_curator: false,
      select_process: false,
      select_user: false,
      loading: false,
      all_users: [],
      all_items: [],
      organ_list: [],
      organ_list_selected: [],
      companies_selected: [],
      list_process: [],
      process_selected: [],
      curatorId:'',
      searchUser:'',
      search_curator:'',
      search_process:'',
      search_user:'',
      addNew: false,
      cloneAllModal: false,
      editModal: false,
      deleteModal: false,
      id: '',
      loader: false,
      company_id: '',
      type_report: '',
      file_link: '',
    }
  },
  methods: {
    fetchCompanies(){
      this.select_user = true
    },

    fetchOrgans() {
      this.organ_list.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all_by_id/${this.company_id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              this.organ_list = result.all
              this.select_curator = true
            }

          })
          .catch();
    },fetchProcess() {
      this.organ_list.length = 0
      if (parseInt(this.type_report)===1 || parseInt(this.type_report)===2) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

        var formdata = new FormData();


        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${this.base_url}/processes/all/by/tree_all_by_process/${this.company_id}`, requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result['items'].length !== 0) {
                this.list_process = result.items
                this.select_process = true
              }

            })
            .catch();
      }else {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

        var formdata = new FormData();


        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${this.base_url}/processes/all_group_by`, requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result['items'].length !== 0) {
                this.list_process = result.items
                this.select_process = true
              }

            })
            .catch();
      }
    },
    select_CompaniesMethod(){
      this.select_user=false
    }, select_processMethod(){
      this.select_process=false
    }, select_curatorMethod(){
      this.select_curator=false
    },
    toggleAll(event) {
      if (event.target.checked) {
        this.organ_list_selected = this.filteredCurator.map(item => item.id);
      } else {
        this.organ_list_selected = [];
      }
    },toggleAllProcess(event) {
      if (event.target.checked) {
        this.process_selected = this.filteredProcess.map(item => item.code);
      } else {
        this.process_selected = [];
      }
    },toggleAllCompanies(event) {
      if (event.target.checked) {
        this.companies_selected = this.filteredCompanies.map(item => item.id);
      } else {
        this.companies_selected = [];
      }
    },
    ResetAll(){
      this.loading = false
      this.company_id = ''
      this.type_report = ''
      this.organ_list.length=0
      this.organ_list_selected.length=0
      this.list_process.length=0
      this.process_selected.length=0
    },
    ExportExcel(){
      this.loader = true
      this.loading = true
      this.all_items.length=0
        if (parseInt(this.type_report)===2){
          fetch(`${this.base_url}/tasks_process/export/${this.company_id}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',

            },
            body: JSON.stringify({
              'organ_list': JSON.stringify(this.organ_list_selected)
            })
          })
              .then(response => response.json())
              .then((response) => {
                if (response.error){
                  toast.error(response.error)
                  this.is_load =false
                  this.loading =false
                  this.loader = false

                  return
                }
                if (response.status){
                  if (response.all){

                    this.all_items = response.all

                  }  if (response.file_link){

                    this.file_link = response.file_link

                  }
                }else {
                  this.loading =false

                }
                this.loader = false


              }).catch((err) => {
          })
        }
        else if (parseInt(this.type_report)===1){
          fetch(`${this.base_url}/tasks_process/export_by_process/${this.company_id}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',

            },
            body: JSON.stringify({
              'process_list': JSON.stringify(this.process_selected)
            })
          })
              .then(response => response.json())
              .then((response) => {
                if (response.error){
                  toast.error(response.error)
                  this.is_load =false
                  return
                }
                if (response.status){
                  if (response.all){

                    this.all_items = response.all

                  }  if (response.file_link){

                    this.file_link = response.file_link

                  }
                }else {
                  this.loading =false

                }
                this.loader = false


              }).catch((err) => {
          })
        }

      else if (parseInt(this.type_report)===3){
        fetch(`${this.base_url}/tasks_process/export_by_process`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',

          },
          body: JSON.stringify({
            'id_companies': JSON.stringify(this.companies_selected),
            'ids_process': JSON.stringify(this.process_selected)
          })
        })
            .then(response => response.json())
            .then((response) => {
              console.log(response)
              if (response.error){
                toast.error(response.error)
                this.is_load =false
                return
              }
              if (response.status){
                if (response.all){

                  this.all_items = response.all

                }  if (response.file_link){

                  this.file_link = response.file_link

                }
              }else {
                this.loading =false

              }
              this.loader = false


            }).catch((err) => {
        })
      }
    },





    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all_for_mother`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                this.all_users.push(item)

              })

            }

          })
          .catch();
    },

    checkIsMother(){
     if (!this.is_mother){
       router.push('/')
     }


    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchItems()
  },
  computed:{
    selectedCuratorNames() {
      return this.filteredCurator
          .filter(item => this.organ_list_selected.includes(item.id))
          .map(item => item.name)
          .join(', ');
    },selectedCompaniesNames() {
      return this.filteredCompanies
          .filter(item => this.companies_selected.includes(item.id))
          .map(item => item.name)
          .join(', ');
    },selectedProcessNames() {
      return this.filteredProcess
          .filter(item => this.process_selected.includes(item.code))
          .map(item => item.name??item.title)
          .join(', ');
    },
    filteredCurator() {
      return this.organ_list.filter(item => {
        return (

             item['name'].includes(this.search_curator)
        );
      });
    },  filteredProcess() {
      return this.list_process.filter(item => {
        return (

             item['title'].includes(this.search_process)
        );
      });
    },filteredCompanies() {
      return this.all_users.filter(item => {
        return (

             item['name'].includes(this.search_user)
        );
      });
    },
    filteredItems() {
      return this.all_users.filter(item => {
        return (
    item['name'].includes(this.searchUser)
        );
      });
    },
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}



p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}
.change_div{
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}
.btn-add-org-post:hover{
  color: #fff;
}
img:hover{
  filter: none;
}
</style>